import React from 'react';
import { useGetDecalQuery } from '../store/apis';
import { Box, CircularProgress } from '@mui/material';
import { useAppSelector } from '../store/store.hook';
import { selectCurrentUserInfo } from '../store/slices';
import { DEFAULT_DECAL_VERSION } from 'enums';

interface DecalProps {
  zoneId: number;
}
export const Decal = ({ zoneId }: DecalProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const {
    data: decalSvg,
    isFetching: isLoading,
    isSuccess,
  } = useGetDecalQuery({ orgSlug, id: zoneId, version: DEFAULT_DECAL_VERSION });
  const [decalImageUrl, setDecalImageUrl] = React.useState('');

  React.useEffect(() => {
    if (isLoading || !isSuccess || !decalSvg) {
      return undefined;
    }
    const url = URL.createObjectURL(new Blob([decalSvg], { type: 'image/svg+xml' }));
    setDecalImageUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [isLoading, isSuccess, decalSvg]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {isLoading ? (
        <CircularProgress color="inherit" size={18} />
      ) : (
        <img
          id="decal-svg"
          src={decalImageUrl}
          alt="decal"
          style={{
            width: '100%',
            height: '125px',
          }}
        />
      )}
    </Box>
  );
};
